import { useEffect } from 'react'
import { Box, Grid, Paper, Button, Typography } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function CarbonTrack() {
  useEffect(()=>{
    sendViewAnalytics('/dashboard', {
            domain: analyticsDomain.dashboard,
            name: analyticsPage.carbonTrackCustomer
      })
  },[])
  return (
    <Grid container id="isNewAccountContent" 
        direction="row" 
        justifyContent="flex-end" 
        spacing={custom.spacing.xxs} 
        width= "100%">
      <Paper id="isCarbonTrack" elevation={0} 
            sx={{ 
              borderRadius: custom.corners5, 
              border: custom.border,
              width: "100%",
              backgroundColor: 'sz.colors.surfaceAccent',
              my: custom.spacing.md,
              ml: custom.spacing.sm,
              p: custom.spacing.md,
            }}
        >
          <Box component="img"
                src="images/monitoringIcon.svg"
              />  
          <Typography component="p" mt={custom.spacing.xxs}
              variant="szHeading.Bold.Medium">
              Monitor your solar energy system
          </Typography>
          <Box>
            <Typography component="p" mt={custom.spacing.xxs}
                variant="szBody.Regular.Medium">
                Log in and get visibility of your solar energy system with up-to-date data on your home’s energy use and generation.
            </Typography>
          </Box>
          <Button variant="contained" id="ctButton"
            onClick={()=>{
              sendClickAnalytics('/dashboard', {
                domain: analyticsDomain.dashboard,
                name: analyticsCta.carbonTrackLogin,
                metadata: {},
              }) 
              window.open("https://solarzero.solarcity.co.nz/", "_blank") 
            }}
            sx={{ mt: custom.spacing.sm, 
                  px: custom.spacing.sm, 
                  py: custom.spacing.xs }}>
            <Typography variant="szBody.Regular.Medium"
              color="#FFF">
              Log in to monitor
            </Typography>
          </Button>
      </Paper>
    </Grid>
  )
}
